<div class="app-main__inner">
  <div class="row">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
      <div class="card filter-card">
        <div class="card-body">
          <div class="row">
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12">
              <div class="position-relative form-group">
                <label for="fromDate" class="form-label">From Date</label>
                <input type="datetime-local" class="form-control" id="fromDate" name="fromDate" [(ngModel)]="fromDate"
                  Placeholder="Enter From Date" />
              </div>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12">
              <div class="position-relative form-group">
                <label for="toDate" class="form-label">To Date</label>
                <input type="datetime-local" class="form-control" id="tomDate" name="toDate" [(ngModel)]="toDate"
                  Placeholder="Enter To Date" />
              </div>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12">
              <div class="position-relative form-group">
                <label for="selectConfig" class="form-label">Select Configuration</label>
                <select name="selectConfig" id="selectConfig" class="form-control" [(ngModel)]="selectedConfig"
                  (ngModelChange)="selectedConfigChanged($event)">
                  <option *ngFor="let conf of configs" [value]="conf.ctName">{{conf.ctName}}</option>
                </select>
              </div>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12">
              <div class="position-relative form-group">
                <label for="selectConfig" class="form-label">Select Parameter</label>
                <select name="selectConfig" id="selectConfig" class="form-control" [(ngModel)]="selectedParam">
                  <option *ngFor="let p of selectedConfigParams" [value]="p">{{p}}</option>

                </select>
              </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12"
              style="display: flex;flex-direction: row;align-items: center;">
              <button type="button" class="btn btn-round btn-primary btn-shadow mx-1" title="Submit" (click)="getData()"
                [appDisableWhile]="isSubmitting"><i class="fa fa-save"></i> Submit</button>
              <button type="button" class="btn btn-round btn-warning btn-shadow mx-1" title="Reset"
                (click)="resetCriteria()"><i class="fa fa-sync"></i> Reset</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
      <div class="card card-chart-status">
        <div class="card-header">
          <h4 class="card-title">Chart</h4>
          <!-- <div class="button-dropdown">
            <div class="dropdown d-inline-block">
              <button type="button" aria-haspopup="true" aria-expanded="false" data-toggle="dropdown"
                class="mb-0 mr-2 dropdown-toggle btn btn-outline-secondary">This Month</button>
              <div tabindex="-1" role="menu" aria-hidden="true" class="dropdown-menu dropdown-menu-right">
                <button type="button" tabindex="0" class="dropdown-item">Menus</button>
                <button type="button" tabindex="0" class="dropdown-item">Settings</button>
                <h6 tabindex="-1" class="dropdown-header">Header</h6>
                <button type="button" tabindex="0" class="dropdown-item">Actions</button>
                <div tabindex="-1" class="dropdown-divider"></div>
                <button type="button" tabindex="0" class="dropdown-item">Dividers</button>
              </div>
            </div>
          </div> -->
        </div>
        <div class="card-body" *ngIf="true">
          <div class="casvas-size" style="width:100%; height:100px;">
            <!-- <canvas baseChart [data]="overviewData" [options]="overviewOptions" [type]="'line'" [plugins]="chartPlugins"
              #overviewChart *ngIf="showChart">
            </canvas> -->
            <canvas id="overviewChart" #overviewChart style="width:100%; height: 100px;">
            </canvas>
          </div>
          <div class="casvas-size" style="width:100%; height:300px;">
            <!-- <canvas baseChart #mainChart id="mainChart" [data]="chartData" [options]="barChartOptions" [type]="'line'"
              style="width:100%" *ngIf="showChart">
            </canvas> -->
            <canvas id="mainChartRef" #mainChartRef style="width:100%">
            </canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>